// frontend/src/App.js

import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import DocumentDetailPage from './pages/DocumentDetailPage';
import NewDocumentPage from './pages/NewDocumentPage';
import MainLayout from './layouts/MainLayout';
import { Box, CircularProgress } from '@mui/material';
import AreasPage from './pages/AreasPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import TeamManagementPage from './pages/TeamManagementPage';
import AcceptInvitationPage from './pages/AcceptInvitationPage';
import FavoritesManagerPage from './pages/FavoritesManagerPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';

const ProtectedRoute = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><CircularProgress /></Box>;
  }

  return user ? <MainLayout><Outlet /></MainLayout> : <Navigate to="/login" />;
};

const AdminRoute = () => {
    const { user } = useAuth();

    if (user && !user.is_company_admin) {
        return <Navigate to="/" />;
    }

    return <Outlet />; 
};


function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} /> 
      <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
      <Route path="/password-reset/confirm/:token" element={<ResetPasswordPage />} />
      <Route path="/aceitar-convite" element={<AcceptInvitationPage />} />
      <Route path="/politica-de-privacidade" element={<PrivacyPolicyPage />} />
      {/* Rotas Protegidas por Login */}
      <Route path="/" element={<ProtectedRoute />}>
        <Route index element={<DashboardPage />} />
        <Route path="novo-pedido" element={<NewDocumentPage />} />
        <Route path="documento/:id" element={<DocumentDetailPage />} />
        <Route path="areas" element={<AreasPage />} />
        <Route path="favoritos" element={<FavoritesManagerPage />} /> 
        
        {/* Rotas Protegidas por Admin */}
        <Route element={<AdminRoute />}>
            <Route path="team-management" element={<TeamManagementPage />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;